const EVENT_NAME = {
    NO_LOGIN: 'no_login', // 未登录时点击
    NO_REMAIN: 'no_remain', // 无抽奖机会时点击
};

const REMAIN_COUNT_PLACEHOLDER = '{count}'

export {
    EVENT_NAME,
    REMAIN_COUNT_PLACEHOLDER
}
